import { useEffect } from 'react';
import PubSub from 'pubsub-js';

export type TUsePubSubCallback<TData> = (message: string, data?: TData) => void;

export type TUsePubSubHook<
  TMessage = string, TData = any, TCallback = TUsePubSubCallback<TData>
> = (message: TMessage, callback: TCallback) => void;

const usePubSub: TUsePubSubHook = (message, callback) => {
  useEffect(() => {
    const token = PubSub.subscribe(message, callback);
    return () => {
      PubSub.unsubscribe(token);
    };
  }, [message, callback]);
};

export default usePubSub;
